import { MsalProvider } from "@azure/msal-react";

import { msalInstance } from "@/lib/auth";
import ChatInterface from "@/components/ChatInterface";
import EmbedLayout from "@/components/embed/EmbedLayout";
import TeamsAuthGate from "@/components/teams/TeamsAuthGate";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";

/**
 * Chrome-less shell for the Microsoft Teams static tab: chat only, no router /
 * sidebar / header — the Teams client already provides the surrounding chrome.
 * Reuses the embed's fluid `EmbedLayout`; the `TeamsAuthGate` handles Teams SDK
 * init + SSO before mounting the chat.
 *
 * MsalProvider is retained for components that read MSAL context; in Teams the
 * token source is the Teams SSO path, not `msalInstance` (see TODO(MA-133) in
 * `lib/teams/auth.ts`).
 */
export default function TeamsApp() {
  return (
    <TooltipProvider>
      <MsalProvider instance={msalInstance}>
        <EmbedLayout>
          <TeamsAuthGate>
            <ChatInterface />
          </TeamsAuthGate>
        </EmbedLayout>
      </MsalProvider>
      <Toaster />
    </TooltipProvider>
  );
}
